/// <reference types="vite/client" />

// Alpine
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'

Alpine.plugin(intersect)

import { createFilterStore } from './default/stores/filterStore'

// Store(s)
document.addEventListener('alpine:init', () => {
    Alpine.store('filterStore', createFilterStore())
})

// Components
import { initHeader } from './default/header'
import { initCollapsible } from './default/collapsible'
import { initIntersectObserver } from './default/intersect-observer'
import { initJSEssentials } from './default/js-essentials'
import { initSlider } from './default/slider'
import { initBasket } from './default/basket'
import { initDialog } from './default/dialog'
import { initFilters } from './default/filters'
import { initVacancyFilter } from './default/vacancyFilter'
import { initVdpImageSlider } from './default/vdp-image-slider'
import { videoEmbedLoader } from './default/video-loader'
import { initSpeculationRules } from './default/speculation-rules'
import { initOnlineafspraken } from './default/online-afspraken.ts'
import { initFinanceTool } from './default/finance-tool'
initCollapsible()
initHeader()
initIntersectObserver()
initJSEssentials()
initSlider()
initBasket()
initDialog()
initFilters()
initVacancyFilter()
initVdpImageSlider()
videoEmbedLoader()
initSpeculationRules()
initOnlineafspraken()
initFinanceTool()

Alpine.start()

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        // eslint-disable-next-line no-console
        console.log('HMR')
    })
}
